import ProductCard from "~/components/ProductCard.jsx";

const ContentPDP = ({ activeCollection }) => {
  // console.log("ContentPDP activeCollection", activeCollection);

  if (!activeCollection || !activeCollection.products) {
    return <p>Invalid collection data</p>;
  }

  const { collectionHandle } = activeCollection;

  return (
    <div className="w-full overflow-y-auto no-scrollbar">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {activeCollection.products.length > 0 ? (
          activeCollection.products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              collectionHandle={collectionHandle}
              pdp={true}
            />
          ))
        ) : (
          <p>No products found</p>
        )}
      </div>
    </div>
  );
};

export default ContentPDP;
